import React from 'react';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * Reusable Sale Order Status Chip Component
 * @param {string} status - Sale order status (Draft, Closed)
 * @param {object} sx - Additional styles
 */
const SaleOrderStatusChip = ({ status, sx = {} }) => {
  const { t } = useTranslation();

  const getStatusConfig = (status) => {
    switch (status?.toLowerCase()) {
      case 'draft':
        return {
          label: t('draft'),
          color: 'warning',
          bgcolor: '#fff3cd',
          textColor: '#856404',
        };
      case 'closed':
        return {
          label: t('closed'),
          color: 'info',
          bgcolor: '#d1ecf1',
          textColor: '#0c5460',
        };
      default:
        return {
          label: status || t('unknown'),
          color: 'default',
          bgcolor: '#e0e0e0',
          textColor: '#616161',
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <Chip
      label={config.label}
      size="small"
      sx={{
        bgcolor: config.bgcolor,
        color: config.textColor,
        fontWeight: 600,
        fontSize: '0.75rem',
        textTransform: 'uppercase',
        ...sx,
      }}
    />
  );
};

export default SaleOrderStatusChip;
